<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-yellow"></div>
    </div>
    <template v-else>
      <div v-if="flag === 'donors'" class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
        <table class="w-full text-left rtl:text-right text-gray-700">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <input id="checkbox-all-search" type="checkbox"
                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                  <label for="checkbox-all-search" class="sr-only">checkbox</label>
                </div>
              </th>
              <th scope="col" class="px-6">Donor Names</th>
              <th scope="col" class="px-6">Blood Group</th>
              <th scope="col" class="px-6">Gender</th>
              <th scope="col" class="px-6">Facility</th>
              <th scope="col" class="px-6">Residence</th>
              <th scope="col" class="px-6">Date Registered</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(donor, index) in filteredDonors" :key="index" class="border-b">
              <td class="w-4 p-4">
                <div class="flex items-center">
                  <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4" />
                  <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                </div>
              </td>
              <td class="px-6 py-2">
                {{ donor.user.first_name }} {{ donor.user?.last_name }}
              </td>
              <td class="px-6 py-2">
                {{ donor.user?.blood_group_id?.description ?? "Unknown" }}
              </td>
              <td class="px-6 py-2">{{ donor.user?.gender }}</td>
              <td class="px-6 py-2">{{ donor.blood_donations[0]?.facility_id?.name ?? "" }}</td>
              <td class="px-6 py-2">{{ donor.county_id?.name ?? "Unknown" }}</td>
              <td class="px-6 py-2">
                {{ new Date(donor.created_at).toLocaleDateString("en-CA") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="flag === 'blood-units'" class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
        <table class="w-full text-left rtl:text-right text-gray-700">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <input id="checkbox-all-search" type="checkbox"
                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="checkbox-all-search" class="sr-only">checkbox</label>
                </div>
              </th>
              <th scope="col" class="px-6">Serial no.</th>
              <th scope="col" class="px-6">Blood Product</th>
              <th scope="col" class="px-6">Blood Group</th>
              <th scope="col" class="px-6">Facility</th>
              <th scope="col" class="px-6">Donation Date</th>
              <th scope="col" class="px-6">Expiry Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in filteredBloodProducts" :key="product.product_id" class="border-b">
              <td class="w-4 p-4">
                <div class="flex items-center">
                  <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4">
                  <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                </div>
              </td>
              <td class="px-6 py-2">{{ product.pint_serial }}</td>
              <td class="px-6 py-2">{{ product.unit_product?.description }}</td>
              <td class="px-6 py-2">{{ product.blood_group?.description }}</td>
              <td class="px-6 py-2">{{ product.facility?.name }}</td>
              <td class="px-6 py-2">{{ product.blood_donation?.date_added ? new
                Date(product.blood_donation?.date_added).toLocaleString() : new
                  Date(product.created_at).toLocaleString() }}</td>
              <td class="px-6 py-2">{{ new Date(product.expiry_date).toLocaleString() ?? 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Pagination -->
      <div class="flex justify-center gap-4 mt-4">
        <button @click="previousPage" :disabled="(flag === 'donors' ? donorCurrentPage : bloodCurrentPage) === 1"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
            viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m15 19-7-7 7-7" />
          </svg>
          Previous
        </button>
        <div class="flex items-center gap-2">
          <button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{
            'bg-custom-blue text-white': page === (flag === 'donors' ? donorCurrentPage : bloodCurrentPage),
            'text-custom-blue': page !== (flag === 'donors' ? donorCurrentPage : bloodCurrentPage)
          }"
            class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button">
            <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
              {{ page }}
            </span>
          </button>
        </div>
        <button @click="nextPage"
          :disabled="(flag === 'donors' ? donorCurrentPage : bloodCurrentPage) === (flag === 'donors' ? donorTotalPages : bloodTotalPages)"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          Next
          <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
            viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m9 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "EcosystemReportsTab",
  components: {},
  mounted() {
    this.userData = this.$store.getters["auth/user"];
  },
  created() {
    this.fetchDonors();
    this.getBloodProducts();
  },
  props: {
    flag: {
      type: String,
      required: true
    },
    searchQuery: {
      type: String,
      default: ""
    },
    filters: {
      type: Object,
      default: () => ({
        blood_group_id: null,
        status: null,
        unit_product_id: null,
        start_date: null,
        end_date: null,
        facility_id: null,
        gender: null,
        county_id: null
      })
    }
  },
  data() {
    return {
      donorCurrentPage: 1,
      donorTotalPages: 0,
      donorPerPage: 10,
      donorTotalCount: 0,
      donors: [],
      bloodCurrentPage: 1,
      bloodTotalPages: 0,
      bloodPerPage: 10,
      bloodTotalCount: 0,
      products: [],
      loading: false,
      isLoading: {},
      userData: '',
      error: null,
    };
  },
  watch: {
    filters: {
      handler(newFilters) {
        console.log('Filters changed in EcosystemReportsTab:', newFilters);
        this.currentPage = 1;
        if (this.flag === 'donors') {
          this.fetchDonors();
        } else if (this.flag === 'blood-units') {
          this.getBloodProducts();
        }
      },
      deep: true,
      immediate: true
    },
    searchQuery(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.flag === 'donors') {
          this.donorCurrentPage = 1;
          this.fetchDonors();
        } else if (this.flag === 'blood-units') {
          this.bloodCurrentPage = 1;
          this.getBloodProducts();
        }
      }
    }
  },
  computed: {
    visiblePages() {
      const currentPage = this.flag === 'donors' ? this.donorCurrentPage : this.bloodCurrentPage;
      const totalPages = this.flag === 'donors' ? this.donorTotalPages : this.bloodTotalPages;
      const maxPagesToShow = 5;
      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

      if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    filteredDonors() {
      return this.donors
    },
    filteredBloodProducts() {
      return this.products
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return 'N/A';
      const parsedDate = new Date(date);
      if (isNaN(parsedDate.getTime())) {
        console.error("Invalid date:", date);
        return null;
      }
      return parsedDate.toISOString().split('T')[0];
    },
    async getBloodProducts() {
      this.loading = true;
      try {
        const queryParams = {
          blood_group_id: this.filters.blood_group_id || null,
          unit_product_id: this.filters.unit_product_id || null,
          facility_id: this.filters.facility_id || null,
          start_date: this.filters.start_date || null,
          end_date: this.filters.end_date || null,
          search_query: this.searchQuery || null,
          page: this.bloodCurrentPage,
          per_page: this.bloodPerPage
        };
        console.log('Fetching blood products with params:', queryParams);
        const response = await api.fetchEcosystemFilteredProducts(queryParams);
        console.log('Blood products API response:', response);
        this.products = response.data || [];
        this.bloodCurrentPage = response.current_page || 1;
        this.bloodTotalPages = response.total_pages || 0;
        this.bloodTotalCount = response.total_count || 0;
      } catch (error) {
        console.error('Error fetching blood products:', error);
        this.error = error.message || 'Failed to fetch blood products';
      } finally {
        this.loading = false;
      }
    },
    async fetchDonors() {
      this.loading = true;
      try {
        const queryParams = {
          blood_group_id: this.filters.blood_group_id ? this.filters.blood_group_id : null,
          gender: this.filters.gender || null,
          county_id: this.filters.county_id ? this.filters.county_id : null,
          facility_id: this.filters.facility_id ? this.filters.facility_id : null,
          start_date: this.filters.start_date || null,
          end_date: this.filters.end_date || null,
          search_query: this.searchQuery || null,
          page: this.donorCurrentPage,
          per_page: this.donorPerPage
        };
        console.log('Fetching donors with params:', queryParams);
        const response = await api.getEcosystemDonors(queryParams);
        this.donors = response.data || [];
        this.donorCurrentPage = response.current_page || 1;
        this.donorTotalPages = response.total_pages || 1;
        this.donorTotalCount = response.total_count || 0;
      } catch (error) {
        console.error('Error fetching donors:', error);
        this.error = error.message || 'Failed to fetch donors';
      } finally {
        this.loading = false;
      }
    },
    goToPage(page) {
      if (this.flag === 'donors') {
        if (page >= 1 && page <= this.donorTotalPages) {
          this.donorCurrentPage = page;
          this.fetchDonors();
        }
      } else if (this.flag === 'blood-units') {
        if (page >= 1 && page <= this.bloodTotalPages) {
          this.bloodCurrentPage = page;
          this.getBloodProducts();
        }
      }
    },
    async previousPage() {
      if (this.flag === 'donors') {
        if (this.donorCurrentPage > 1) {
          this.donorCurrentPage--;
          await this.fetchDonors();
        }
      } else if (this.flag === 'blood-units') {
        if (this.bloodCurrentPage > 1) {
          this.bloodCurrentPage--;
          await this.getBloodProducts();
        }
      }
    },
    async nextPage() {
      if (this.flag === 'donors') {
        if (this.donorCurrentPage < this.donorTotalPages) {
          this.donorCurrentPage++;
          await this.fetchDonors();
        }
      } else if (this.flag === 'blood-units') {
        if (this.bloodCurrentPage < this.bloodTotalPages) {
          this.bloodCurrentPage++;
          await this.getBloodProducts();
        }
      }
    },
    applyFilters() {
      if (this.flag === 'donors') {
        this.donorCurrentPage = 1;
        this.fetchDonors();
      } else if (this.flag === 'blood-units') {
        this.bloodCurrentPage = 1;
        this.getBloodProducts();
      }
    },
    resetFilters() {
      if (this.flag === 'donors') {
        this.donorCurrentPage = 1;
        this.fetchDonors();
      } else if (this.flag === 'blood-units') {
        this.bloodCurrentPage = 1;
        this.getBloodProducts();
      }
      this.$emit('cancel-filters');
    },
  },
};
</script>

<style lang="css" scoped></style>